

























import Vue from "vue";
export default Vue.extend({
  inheritAttrs: false,
  props: [
    "title",
    "databind",
    "loading",
    "centered",
    "dialogstyle",
    "maskClosable",
    "width",
    "showmodal",
    "idmodal",
    "forceRender",
  ],
  data() {
    return {
      data:null,
      visible: false,
    };
  },
  watch: {
    showmodal: function (e) {
      if (e) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
  },
});
